import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  Platform,
} from "react-native";
import * as Haptics from "expo-haptics";
import { Feather } from "@expo/vector-icons";
import colors from "../constants/colors";
import { normalize } from "../utils/normalize";
import Row from "./Row";
import { JOB_TYPES } from "../constants/jobTypes";

const JobTypeFilter = ({
  isDev,
  selectedJobType,
  onJobTypeChange,
  showInternational,
  onInternationalChange,
  internationalFilter,
  internationalStyle,
  style,
}) => {
  const [showInternationalJobs, setShowInternationalJobs] = useState(false);

  const jobTypes = JOB_TYPES.map(type => ({
    name: type.name,
    id: type.apiId
  }));

  // Initialize international checkbox state from internationalFilter prop
  useEffect(() => {
    if (internationalFilter) {
      setShowInternationalJobs(
        internationalFilter.type === "international" ||
        (internationalFilter.type === "all" && internationalFilter.countries?.length > 0)
      );
    }
  }, [internationalFilter]);

  // Reset international checkbox when switching to Locum
  useEffect(() => {
    if (selectedJobType === 0) {
      setShowInternationalJobs(false);
    }
  }, [selectedJobType]);

  const handleJobTypePress = (index) => {
    if (Platform.OS === "ios") {
      Haptics.selectionAsync();
    }
    onJobTypeChange(index);
  };

  const handleInternationalToggle = () => {
    if (Platform.OS === "ios") {
      Haptics.selectionAsync();
    }
    const newValue = !showInternationalJobs;
    setShowInternationalJobs(newValue);
    onInternationalChange(newValue);
  };

  if (!isDev) {
    return null;
  }

  return (
    <View style={style}>
      <View style={{ backgroundColor: 'white', paddingVertical: 8 }}>
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={{ paddingHorizontal: 16 }}
        >
          <View style={{ flexDirection: 'row' }}>
            {jobTypes.map((item, index) => {
              const isSelected = index === selectedJobType;
              return (
                <TouchableOpacity
                  key={item.id}
                  onPress={() => handleJobTypePress(index)}
                  style={{
                    marginRight: index < jobTypes.length - 1 ? 4 : 0,
                  }}
                >
                  <View
                    style={{
                      paddingVertical: 10,
                      paddingHorizontal: 16,
                      backgroundColor: isSelected ? colors.primary : 'rgba(0,0,0,0.02)',
                      borderRadius: 12,
                      minWidth: 85,
                      alignItems: 'center',
                    }}
                  >
                    <Text
                      style={{
                        fontSize: normalize(14),
                        fontWeight: isSelected ? '600' : '400',
                        color: isSelected ? 'white' : '#666',
                      }}
                    >
                      {item.name}
                    </Text>
                  </View>
                </TouchableOpacity>
              );
            })}
          </View>
        </ScrollView>
      </View>

    </View>
  );
};

export default JobTypeFilter;